import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';

import { ProfileService } from '../../features/profile/data-access/profile.service';

export const aiAccessGuard: CanActivateFn = (): boolean | UrlTree => {
  const profileService = inject(ProfileService);
  const router = inject(Router);

  const hasGeminiKey = !!profileService.geminiApiKey();
  const hasLlmConfig =
    !!profileService.useOwnLlm() &&
    !!profileService.llmUrl() &&
    !!profileService.llmModelName();

  return hasGeminiKey || hasLlmConfig || router.createUrlTree(['/profile']);
};
